import styled from 'styled-components';

// downshift requires the dropdown be present in the DOM even when it is not visible
export const Relative = styled.div<{ isOpen?: boolean }>`
  display: ${({ isOpen = false }) => (isOpen ? 'block' : 'none')};
  position: relative;
  height: 100%;
`;

export const Absolute = styled.div`
  position: absolute;
  z-index: ${({ theme }) => theme.zIndices.DROPDOWN};
  width: 100%;
  height: 100%;
`;
